module.exports = __webpack_public_path__ + "img/br34.df2cd88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br34.jpg
// module id = EvLG
// module chunks = 0